<template>
  <el-form ref="editForm" :model="editForm" label-width="80px" style="margin:20px;width:60%;min-width:600px;"
    @submit.prevent="onSubmit" :rules="editformrules">
    <el-form-item label="我的昵称">
      <el-input v-model="editForm.uRealName"></el-input>
    </el-form-item>

    <el-form-item label="旧密码" prop="PasswordOld">
      <el-input v-model="editForm.PasswordOld" type="text" auto-complete="off"></el-input>
    </el-form-item>
    <el-form-item label="新密码" prop="PasswordNew">
      <el-input v-model="editForm.PasswordNew" show-password auto-complete="off"></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="LoginPWDConfirm">
      <el-input v-model="editForm.LoginPWDConfirm" show-password auto-complete="off"></el-input>
    </el-form-item>

    <el-form-item>
      <el-button @click="onSubmit" type="primary">更新</el-button>
      <el-button @click.native.prevent>取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { changePassword } from "../../api/api";
export default {
  data () {
    return {
      PasswordOld: "",
      PasswordNew: "",
      LoginPWDConfirm: "",

      editForm: {
        PasswordOld: "",
        PasswordNew: "",
        LoginPWDConfirm: "",
        uRealName: "",

      },
      token: {
        Authorization: "Bearer "
      },

      editformrules: {
        PasswordOld: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        PasswordNew: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, max: 20, message: '密码长度在6到20个字符之间', trigger: 'blur' }
        ],
        LoginPWDConfirm: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { min: 6, max: 20, message: '密码长度在6到20个字符之间', trigger: 'blur' },
          { validator: this.validatePasswordConfirm, trigger: 'blur' }
        ],
      },
    };
  },
  mounted () {
    // let tokenStr = window.localStorage.Token;
    // this.token.Authorization = "Bearer " + tokenStr;

    var user = JSON.parse(window.localStorage.user);
    this.editForm.uRealName = user ? user.uRealName : "";
  },
  methods: {
    validatePasswordConfirm (rule, value, callback) {
      console.log(value + "value");
      if (value !== this.editForm.PasswordNew) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    },
    onSubmit () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.editForm);
            console.log(JSON.stringify(para) + "para");
            changePassword(para).then((res) => {
              if (res.data.success) {
                this.addLoading = false;
                console.log("修改的是当前账号的密码");
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.addFormVisible = false;
                this.logout();
              } else {
                this.$message({
                  message: res.data.msg + "请重新登录",
                  type: "error",
                });
                this.addLoading = false;
              }
            }).catch((error) => {
              this.$refs["editForm"].resetFields();
              this.addLoading = false;
              this.$message({
                message: error.message || '修改密码失败,请重试',
                type: "error",
              });
            });
          });

        } else {
          return false;

        }
      });

      console.log("Form submitted!");
    },
    logout: function () {
      var _this = this;
      window.localStorage.removeItem('user');
      window.localStorage.removeItem('Token');
      window.localStorage.removeItem('TokenExpire');
      window.localStorage.removeItem('NavigationBar');
      window.localStorage.removeItem('refreshtime');
      window.localStorage.removeItem('router');
      window.sessionStorage.removeItem('checkId');
      sessionStorage.removeItem("Tags");

      global.antRouter = [];

      this.tagsList = [];
      this.routes = [];
      this.$store.commit("saveTagsData", "");
      this.$store.commit("saveToken", "");
      if (global.IS_IDS4) {
        applicationUserManager.logout();
      } else {
        _this.$router.push('/login');
      }
    },
  }
};
</script>

<style>
.plus-sign {
  line-height: 120px !important;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.markdown-body {
  height: 500px !important;
}
</style>